import React, { useEffect } from 'react';
import { MAP_LINE_Z_INDEX } from '../../constants/constants';
import { createPolyline, lineStringFromEncodedPolyline } from '../../services/here-maps/here-map-wrapper';
import { HereMapColors } from '../../styles/agistics-colors';
import { HerePoint } from '../../types';
import { HereMapContext } from './here-map-context';
import { removeMapObjectById } from './standard-route-helpers';
import { useDraggableStandardRoute } from './use-draggable-standard-route';

interface HereMapLineProps {
    flexiblePolyline: string;
    setDraggableRoute?: (h: HerePoint[]) => void;
    onRouteDrawn?: () => void;
}

export const StandardRouteLines: React.FC<HereMapLineProps> = (props) => {
    const { flexiblePolyline, setDraggableRoute, onRouteDrawn } = props;
    const context = React.useContext(HereMapContext);
    setDraggableRoute && useDraggableStandardRoute(flexiblePolyline, setDraggableRoute);

    useEffect(() => {
        // dont keep track of this in useState, will be unreliable
        let polylineId = 0;
        if (context.map) {
            const lineString = lineStringFromEncodedPolyline(flexiblePolyline);

            const polyline = createPolyline(lineString, {
                style: {
                    lineWidth: 4,
                    strokeColor: HereMapColors.STANDARD_ROUTE,
                },
                zIndex: MAP_LINE_Z_INDEX.StandardRoute,
            });

            polylineId = polyline.getId();
            context.map.addObject(polyline);
        }

        onRouteDrawn && onRouteDrawn();

        return () => {
            if (context.map) {
                removeMapObjectById(context, polylineId);
            }
        }
    }, [flexiblePolyline, context.map]);

    return null;
};
